module.exports = __webpack_public_path__ + "media/images/small_ad_banner-5885f6589d7c3777c0a5734c70218d82.png";